<template>
    <div class="SidebarToggleButtons">
        <WIcon
            :icon="isOpen ? 'close' : 'menu'"
            :size="20"
            color="accent-blue"
            style="cursor: pointer;"
            @click="toggleSidebar"
        />
        <div
            class="FiltersLabel"
            @click="toggleSidebar"
        >
            <WIcon
                :size="14"
                icon="filter"
                color="dark"
                style="margin-right: 4px;"
            />
            <WText
                :size="18"
                weight="semi"
                color="gray01"
                style="margin-top: 3px;"
            >
                {{ $t('filters.title') }}
            </WText>
            <div
                v-if="isFiltering"
                :class="['ActiveMark', entityColor]"
            />
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'FiltersSidebarToggle',
    props: {
        isOpen: VueTypes.bool,
        isFiltering: VueTypes.bool,
        entityColor: VueTypes.string,
    },
    methods: {
        toggleSidebar () {
            this.$emit('toggle', !this.isOpen)
        },
    },
}
</script>

<style lang="scss" scoped>
.SidebarToggleButtons {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 25px;
    .FiltersLabel {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        transform: rotate(90deg);
        transform-origin: bottom left;
        position: absolute;
        left: 0;
        top: 0;
    }
    .ActiveMark {
        width: 10px;
        height: 10px;
        background-color: $danger;
        border-radius: 100%;
        margin-left: 8px;
        margin-top: 2px;
        flex-shrink: 0;
        &.turquoise {
            background-color: $turquoise;
        }
        &.cyan {
            background-color: $cyan;
        }
        &.violet {
            background-color: $violet;
        }
        &.pink {
            background-color: $pink;
        }
    }
}
</style>
